import { useTheme } from '@mui/material';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

interface LockProps extends SvgIconProps {
  size?: number;
}

const Lock: React.FC<LockProps> = (props) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} style={{ ...props.style, fontSize: props.size ?? 22 }} viewBox="0 0 24 24">
      <g>
        <path
          d="M19.75 11.4453H5.75C4.64543 11.4453 3.75 12.3407 3.75 13.4453V20.4453C3.75 21.5499 4.64543 22.4453 5.75 22.4453H19.75C20.8546 22.4453 21.75 21.5499 21.75 20.4453V13.4453C21.75 12.3407 20.8546 11.4453 19.75 11.4453Z"
          fill={theme.palette.darkBlue.main}
          stroke={theme.palette.darkBlue.main}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 11.4453V7.44531C7.75 6.11923 8.27678 4.84746 9.21447 3.90978C10.1521 2.9721 11.4239 2.44531 12.75 2.44531C14.0761 2.44531 15.3479 2.9721 16.2855 3.90978C17.2232 4.84746 17.75 6.11923 17.75 7.44531V11.4453"
          stroke={theme.palette.darkBlue.main}
          fill="transparent"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export default React.memo(Lock);
